import moment from 'moment';
import { Method, send } from '../../lib/MyHttp';

/**
 * 리스트
 */
export const GetList = (component, params, success, fail) => {
    let paramsT = { ...params };
    if (!params['name']) delete paramsT['name'];

    send(component, Method.GET, '/a/notice', paramsT, success, fail);
};

/**
 * 정보
 */
export const Get = (component, id, success, fail) => {
    const params = {};
    send(component, Method.GET, '/a/notice/' + id, params, success, fail);
};

/**
 * 등록
 */
export const Create = (component, params, success, fail) => {
    const paramsT = {
        title: params.title,
        content: params.content,
        files: params.files,
        status: params.status,
        type: params.type,
        openedAt: moment(params.openedAt).format('YYYY-MM-DD'),
        closedAt: moment(params.closedAt).format('YYYY-MM-DD'),
    };

    send(component, Method.POST, '/a/notice/', paramsT, success, fail);
};

/**
 * 업데이트
 */
export const Update = (component, id, params, success, fail) => {
    const paramsT = {
        title: params.title,
        content: params.content,
        files: params.files,
        status: params.status,
        type: params.type,
        openedAt: moment(params.openedAt).format('YYYY-MM-DD'),
        closedAt: moment(params.closedAt).format('YYYY-MM-DD'),
    };

    send(component, Method.PUT, '/a/notice/' + id, paramsT, success, fail);
};

/**
 * 삭제
 */
export const Delete = (component, id, success, fail) => {
    const params = {};
    send(component, Method.DELETE, '/a/notice/' + id, params, success, fail);
};
